<template>
  <div
    :class="b()"
  >
    <span :class="b('container')">
      <template v-if="!$slots.default">
        <ImageOrIcon
          src="iconlichengbei"
          :size="18"
          symbol
        />
        <i18n
          :class="[b('title'), 'text-ellipsis']"
          path="valueReachCard.person.title1"
          tag="p"
        >
          <template
            #number1
          >
            <b
              :class="b('light-text')"
            >
              {{ toMinuteUnit(receiverName.totalTime) }}
            </b>
          </template>
          <template
            #number2
          >
            <b
              :class="b('light-text')"
            >
              {{ receiverName.convertValue }}
              {{ getUnitKey(receiverName.convertUnit, null, receiverName.convertValue) }}
            </b>
          </template>
        </i18n>
        <el-link
          type="primary"
          :underline="false"
          @click.stop="handleClose(true)"
        >{{ $t('system.message.viewDetails') }}</el-link>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </span>
    <span class="close-btn">
      <em
        class="zkicon iconguanbi"
        @click="handleClose"
      />
    </span>
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import { getUnitKey, toMinuteUnit } from './util';
import { setHasRead } from '@/api/message';

export default {
  name: 'ValueReachBanner',
  bemNS: theme.bemNS,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      receiverName: null
    };
  },
  created() {
    this.receiverName = JSON.parse(this.item.receiverName);
  },
  methods: {
    async handleClose(isToggle) {
      // 延迟设置已读状态
      setTimeout(async() => {
        await setHasRead({ id: this.item.reminderReceiveId });
        this.eventBus.$emit('message:sys:read', this.item.reminderReceiveId);
      }, 2000);
      if (isToggle === true) {
        this.eventBus.$emit('openNoticeMsg', 'sys');
      }

      this.$emit('close');
    },
    getUnitKey(unit, msg, num) {
      return getUnitKey(unit, msg, this.$i18n, num);
    },
    toMinuteUnit(num) {
      return toMinuteUnit(num, this.$i18n);
    }
  }
};
</script>

<style lang="scss">
@include b(value-reach-banner) {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  height: 50px;
  z-index: 1;
  background: #fff;
  .zkicon {
    font-size: 15px;
  }
  .zk-symbol-icon {
    margin-right: 12px;
  }
  .el-link {
    margin-left: 24px;
  }
  .iconguanbi {
    cursor: pointer;
  }
  @include e(container) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
  }
  @include e(desc) {
    margin-left: 4px;
    font-weight: var(--weight-font-Semiblod);
  }

  @include e(light-text) {
    color: var(--primary-color);
  }
  .close-btn {
    flex-shrink: 0;
    margin-right: 16px;
  }
}
</style>
